export default {
  // Search selectors
  transactionDirection: "Transaction Direction",
  virtualCurrency: "Virtual Currency",
  fiatCurrency: "Fiat Currency",
  pleaseSelect: "Please Select",
  totalAmount: "Total Amount",
  transactionAmount: "Transaction Amount",
  minAmount: "Min Amount",
  maxAmount: "Max Amount",
  maxAmountWarning: "Max amount must be ≥ min amount",

  // Date picker
  dateRangeSeparator: "→",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",

  // Buttons
  reset: "Reset",
  query: "Query",

  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns
  direction: "Direction",
  currency: "Currency",
  quantity: "Quantity",
  unitPrice: "Unit Price",
  fiatCurrencyColumn: "Fiat Currency",
  totalMoney: "Total Amount",
  transactionTime: "Transaction Time",

  // Transaction direction
  buy: "Buy",
  sell: "Sell",
  unknown: "Unknown",

  // Empty state
  noOtcData: "No OTC transaction data parsed from current investigation file",

  // Download
  downloadDetails: "Download Details",
  downloadFileName: "Data Details",
};
